// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__header {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__selected {
    opacity: 1;
  }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell:not(.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__selected) {
    opacity: 0.8;
  }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__dragIcon {
    display: none;
    align-items: center;
    height: 100%;
    padding: 0px 5px;
    color: inherit;
    position: absolute;
    right: 5px;
  }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell:hover .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__dragIcon {
    display: flex;
  }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__centerLabel {
    display: flex;
    justify-content: center;
  }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cellLabel {
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cellLabel .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__label {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cellLabel .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__imputationCandidat {
      font-style: italic;
    }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cellLabel .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__imputationCandidat::before {
        content: '(';
      }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cellLabel .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__imputationCandidat::after {
        content: ')';
      }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cellLabel .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__itemColor {
      height: 25px;
      max-height: calc(100% - 10px);
      width: 25px;
      border-radius: 4px;
      margin-right: 10px;
    }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell .app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__colorBadge {
    position: absolute;
    width: 25px;
    height: 70%;
    min-height: 25px;
    right: 10px;
    opacity: 0.6;
    background-color: grey;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

.app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__isDragging {
  box-shadow: 5px 0 9px 0 rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./app/components/Table/Cells/ColumnGanttTree/ColumnGanttTree.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AAyEpB;;AAvEE;IACE,UAAU;EACZ;;AAEA;IACE,YAAY;EACd;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;;AACA;IACE,aAAa;EACf;;AAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;AAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EAyBrB;;AAvBE;MACE,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;IACzB;;AAEA;MACE,kBAAkB;IAOpB;;AANE;QACE,YAAY;MACd;;AACA;QACE,YAAY;MACd;;AAGF;MACE,YAAY;MACZ,6BAA6B;MAC7B,WAAW;MACX,kBAAkB;MAClB,kBAAkB;IACpB;;AAGF;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;AAGF;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".header {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n}\n\n.cell {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n\n  &.selected {\n    opacity: 1;\n  }\n\n  &:not(.selected) {\n    opacity: 0.8;\n  }\n\n  .dragIcon {\n    display: none;\n    align-items: center;\n    height: 100%;\n    padding: 0px 5px;\n    color: inherit;\n    position: absolute;\n    right: 5px;\n  }\n  &:hover .dragIcon {\n    display: flex;\n  }\n\n  &.centerLabel {\n    display: flex;\n    justify-content: center;\n  }\n\n  .cellLabel {\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n\n    .label {\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n    .imputationCandidat {\n      font-style: italic;\n      &::before {\n        content: '(';\n      }\n      &::after {\n        content: ')';\n      }\n    }\n\n    .itemColor {\n      height: 25px;\n      max-height: calc(100% - 10px);\n      width: 25px;\n      border-radius: 4px;\n      margin-right: 10px;\n    }\n  }\n\n  .colorBadge {\n    position: absolute;\n    width: 25px;\n    height: 70%;\n    min-height: 25px;\n    right: 10px;\n    opacity: 0.6;\n    background-color: grey;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.isDragging {\n  box-shadow: 5px 0 9px 0 rgba(0, 0, 0, 0.4);\n  position: relative;\n  z-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__header`,
	"cell": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cell`,
	"selected": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__selected`,
	"dragIcon": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__dragIcon`,
	"centerLabel": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__centerLabel`,
	"cellLabel": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__cellLabel`,
	"label": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__label`,
	"imputationCandidat": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__imputationCandidat`,
	"itemColor": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__itemColor`,
	"colorBadge": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__colorBadge`,
	"isDragging": `app-components-Table-Cells-ColumnGanttTree-___ColumnGanttTree-module__isDragging`
};
export default ___CSS_LOADER_EXPORT___;
